<template>
  <div>
    <div
      ref="spotlightBlackdrop"
      class="spotlight-blackdrop"
      @click="hide"
    ></div>
    <div
      class="spotlight-input-v2__container"
      ref="spotlight-input-v2"
      v-click-outside="{
        exclude: ['spotlight-input-v2'],
        handler: 'hide',
      }"
    >
      <button 
        :class="[
            search && 'invisible',
            'btn',
        ]" 
        @click="open"
      >
        <i class='spotlight-input-v2__btn-icon'></i>
      </button>
      <div
        :class="[
          search && 'spotlight-input-v2__input-box--active',
          'spotlight-input-v2__input-box',
        ]"
      >
        <input
          ref="spotlightInput"
          id="spotlightInput"
          type="text"
          @keydown="debounce"
          v-model="picked"
          placeholder="Suchen..."
          :class="['spotlight-input-v2__input']"
        />
        <i
          @click.stop="clear"
          :class="[
            picked && 'spotlight-input-v2__icon-close--active',
            'spotlight-input-v2__icon-close icon-close',
          ]"
        ></i>
        <ul class="spotlight-input-v2__sugestions">
          <template v-for="item in result">
            <li :key="item.id">
              <a
                class="spotlight-input-v2__link"
                @mousedown.prevent
                :href="item.url"
              >
                <span class="spotlight-input-v2__title" v-html="item.highlight ? item.highlight : item.title" />
                <span class="spotlight-input-v2__badge" v-if="item.type">
                    {{ item.type }}
                </span>
              </a>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    uri: String,
    result: Array,
  },
  data() {
    return {
      picked: "",
      search: false,
    };
  },
  methods: {
    open() {
      this.search = true;
      this.$nextTick(() => this.setFocus());
      if (window.innerWidth < 576) {
        this.$refs.spotlightBlackdrop.classList.add(
          "spotlight-blackdrop--active"
        );
        document.body.classList.add("overflow-hidden");
      }
    },
    hide() {
      this.search = false;
      if (window.innerWidth < 576) {
        this.$refs.spotlightBlackdrop.classList.remove(
          "spotlight-blackdrop--active"
        );
        document.body.classList.remove("overflow-hidden");
      }
    },
    setFocus() {
      this.$refs.spotlightInput.focus();
    },
    clear() {
      this.picked = "";
      this.result = [];
      this.setFocus();
    },
    spotlight() {
      fetch(this.uri + "?arg=" + this.picked)
        .then((response) => response.json())
        .then((data) => {
          this.result = data.result;
        })
        .catch((error) => {
          window.console.log("Error at ToggleAjax: " + error);
        });
    },
    debounce: _.debounce(function () {
      this.spotlight();
    }, 300),
  },
};
</script>

<style>
</style>
